import type { IdentifiableChainCollection, } from "@types";

/**
 * Retrieves a collection of supported blockchain chains with their basic information.
 * 
 * @todo This should be replaced with a call to the backend API.
 * @returns {Promise<IdentifiableChainCollection>} A promise that resolves to an object containing chain information
 * indexed by their chain IDs. Each chain entry includes:
 * - id: The chain's unique identifier
 * - name: The human-readable name of the chain
 * - logo: URL to the chain's logo image
 */
export const getChains = async (): Promise<IdentifiableChainCollection> => {
  const result: IdentifiableChainCollection = {
    1: {
      id: 1,
      name: "Ethereum",
      logo: "https://etherscan.io/images/svg/brands/ethereum-original-light.svg",
    },
    42161: {
      id: 42161,
      name: "Arbitrum",
      logo: "https://arbiscan.io/assets/arbitrum/images/svg/logos/chain-dark.svg",
    },
  };
  return result;
}
